import React, { Fragment } from 'react';

class Body extends React.Component 
{
    render() 
	{
        //let router = -1
        let router = ['login','information','filling'].find(res=>{return window.location.pathname.indexOf(res)!==-1})
        return (
            <div id="-sf-body-id-" className="sg-body page-overflow sd-middle">
                <div className='sg-body-center'>
                    <Fragment>
                        {this.props.children}
                    </Fragment>
                </div>
                <img className='sg-bottom-img' alt='#' src={require('../img/business/pageBg.png')} style={{display: router ? "flex" : "none"}}/>
            </div>
        );
    }
}

export default Body